module.exports = __webpack_public_path__ + "media/mypage/images/menu/spm8-84c0bab7cb3986fe9a34daf4d084bf1c.png";